import axios from "axios";

const getCsrfToken = () => {
    const metaTag = document.querySelector('meta[name="csrf-token"]');
    return metaTag ? metaTag.getAttribute('content') : null;
};

export const client = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    baseURL:
        process.env.NODE_ENV === 'development' ?
            'http://leaderos-test.com:8888/auto-install' : '/auto-install',
});

client.interceptors.request.use(
    (config) => {
        if (config.method !== 'get') {
            const token = getCsrfToken();
            if (token) {
                config.headers['X-CSRF-Token'] = token;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getLanguages = async () => await client.get('/data/languages');

export const createAdmin = (admin, loginProvider) => client.post('/steps/admin', {
    loginProvider: loginProvider,
    accountUsername: loginProvider === 'default' ? admin.realname.toLowerCase() : admin.username,
    accountRealname: admin.realname,
    accountEmail: admin.email,
    accountPassword: admin.password,
    accountPasswordRe: admin.confirmPassword,
});
export const run = (apiKey, game, loginProvider, admin) => client.post('/steps/run', {
    apiKey: apiKey,
    game: game,
    loginProvider: loginProvider,
    
    accountUsername: loginProvider === 'default' ? admin.realname.toLowerCase() : admin.username,
    accountRealname: admin.realname,
    accountEmail: admin.email,
    accountPassword: admin.password,
    accountPasswordRe: admin.confirmPassword,
    accountAvatar: admin.avatar
});